import { DataQueryParams } from 'common/src/query-params/DataQueryParams';

export default function formatQueryParams({
  filters,
  ...rest
}: DataQueryParams = {}) {
  return {
    ...(filters && { filters: JSON.stringify(filters) }),
    ...rest,
  };
}
